module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./KeyCustomersView.js"));
	}, "KeyCustomersView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=KeyCustomersView!./src/pages/Shop/Visitor/KeyCustomers/KeyCustomersView.js
// module id = 1813
// module chunks = 367